import * as React from 'react';
import Button from '@mui/material/Button';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogContentText from '@mui/material/DialogContentText';
import DialogTitle from '@mui/material/DialogTitle';
import { Typography } from '@mui/material';
import { Box } from '@mui/system';
import { IoMdClose } from "react-icons/io";


export default function ResendDialog(props) {
 

  return (
    <React.Fragment>
      
      <Dialog
        open={props.open}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
        maxWidth="xs"
        fullWidth
      >
        <Box sx={{position:'absolute',top:10,right:10,fontSize:'18px',cursor:'pointer'}} onClick={props.handleClose}>
            <IoMdClose />
        </Box>
        <DialogTitle id="alert-dialog-title">
         <Typography variant='h4'> {"Resend link"}</Typography>
        </DialogTitle>
        <DialogContent>
          <DialogContentText id="alert-dialog-description">
                Are you sure you want to resend the payment link?
          </DialogContentText>
        </DialogContent>
        <DialogActions sx={{display:'flex',justifyContent:'center'}}>
          <Button disabled={props.isLoading?true:false} variant='contained' color='secondary' onClick={props.handleSubmit}>Proceed</Button>
         
        </DialogActions>
      </Dialog>
    </React.Fragment>
  );
}
